import { Component, OnInit, OnDestroy, ViewChild, HostListener, Input, ViewChildren, AfterViewInit } from '@angular/core';
import * as Chart from 'chart.js';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { getQueryParamFromAncestorRoute, getParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { IssueService } from '../../../../services/issue.service';

@Component({
    selector: 'issues-recent-read-data-chart',
    template: '<canvas id="basechart" #basechart *ngIf="chartData.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { width: 86%; position: relative; display:block; }'],
})
export class IssuesRecentReadDataChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    ctx: any;
    public subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    chartData: any[] = [];
    heatGradientStroke: any;
    hotWaterGradientStroke: any;
    coldWaterGradientStroke: any;
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    siteId: number = 0;
    agedDebt: any;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {

        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId') ? getQueryParamFromAncestorRoute(this.route, 'siteId') : 0;

        this.search();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    search() {

        this.issueService.getRecentReadDataConsumptionSummary(this.clientId, this.siteId).then((result) => {
            this.chartData = [];

            this.agedDebt = result;  

            if (result) {
                if (result.within1Day > 0) { this.chartData.push({ x: result.within1Day, label: 'Within 1 day', colour: '#93c01f' }); }
                if (result.within1_3Days > 0) { this.chartData.push({ x: result.within1_3Days, label: 'Within 1 - 3 days', colour: '#F9E533' }); }
                if (result.within3_7Days > 0) { this.chartData.push({ x: result.within3_7Days, label: 'Within 3 - 7 days', colour: '#FFC000' }); }
                if (result.over7Days > 0) { this.chartData.push({ x: result.over7Days, label: 'over 7 days', colour: '#c82b2b' }); }
            }

            this.createChart();
        });
    }

    private getChartConfig(): any {
        let config = {
            type: 'horizontalBar',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'No. of meters',
                        }
                    }],
                    yAxes: [
                        {
                            stacked: true,
                            display: false,
                            barThickness: 100,
                            scaleLabel: {
                                display: false,
                                labelString: 'Debt Value (£)'
                            }
                        }
                    ]

                }
            }
        }

        return config;
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        if (this.chartData.length > 0) {
            for (let i = 0; i < this.chartData.length; i++) {

                if (this.chartData[i].x > 0) {
                    datasets.push({
                        label: this.chartData[i].label,
                        yAxisID: 'y-axis-0',
                        data: [this.chartData[i].x],
                        backgroundColor: this.chartData[i].colour,
                    });
                }
            }
        }

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                labels: ['Recent read data'],
                datasets: datasets,
            }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            if (!this.basechart || !this.basechart.first) return;
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }

}
